<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: '12px',}">
        <template #title>
            <div style="display: flex; align-items: center; justify-content: start; font-weight: 600; ">
                {{$t('schedule-calendar.title')}}          
            </div>
        </template>
        <a-spin :spinning="isLoading" size="large">
            <div class="spin-content">
                <a-calendar :loading="true" v-show="selectedOfficial" @select="onDateChanged" style="min-height: 650px; max-height: 650px; overflow-y: scroll !important;">
                    <ul slot="dateCellRender" slot-scope="value" class="events" style="display: flex; align-items: center; justify-content: center;flex-direction: column;margin-top: 10px;">
                    <li v-for="item in getListData(value)" :key="item.label" >
                        <a-tooltip>
                            <template slot="title">
                                {{ item.longText }}
                            </template>
                            <a-badge :status="item.type" :text="item.content" />
                        </a-tooltip>
                        
                    </li>
                    </ul>
                    <template slot="monthCellRender" slot-scope="value">
                    <div v-if="getMonthData(value)" class="notes-month">
                        <section>{{ getMonthData(value) }}</section>
                        <!-- <span>Backlog number</span> -->
                    </div>
                    </template>
                </a-calendar>
            
                <div v-show="!selectedOfficial" style="min-height: 650px; max-height: 650px; overflow-y: scroll !important; display: flex; align-items: center; justify-content: center;">
                    <a-empty
                        image="/images/empty.png"
                        :image-style="{ height: '60px' }">
                        <span slot="description"> 
                            <b class="text-primary">No Official Selected</b>
                        </span>
                    </a-empty>
                </div>
            </div>
        </a-spin>
    </a-card>
</template>
<script>
import { mapState } from 'pinia';
import { useMonthlySchedulesStore } from '../../stores/monthly-schedules-store';
import moment from 'moment'
export default {
    data() {
        return {
            isLoading: false,
            selectedDate: moment()
        }
    },
    computed: {
        ...mapState(useMonthlySchedulesStore, [ 'selectedOfficial', 'fetchMonthlyStats', 'currentMonthlyStats' ]),
        
    },
    methods: {
        getListData(value) {
            
            let d = value.format('YYYY-MM-DD');
            let filtered = this.currentMonthlyStats.filter(s => s.label == d);
            let list = [];
            filtered.forEach(d => {
                if (d.type == 'ONLINE') {
                    list.push({ type: 'success', content: '(O) ' + d.count, label: d.label + '-' + d.type, longText: 'Online Meetings: ' + d.count })
                } else {
                    list.push({ type: 'error', content: '(IP) ' + d.count, label: d.label + '-' + d.type, longText: 'In Person Meetings: ' + d.count })
                }
            });
            return list;
        },

        getMonthData(value) {
            if (value.month() === 8) {
                return 1394;
            }
        },
        onDateChanged(d) {
            if (this.selectedOfficial) {
                this.isLoading = true;
                this.selectedDate = d;
                this.fetchMonthlyStats(this.selectedDate.year(), this.selectedDate.month() + 1).then(res => {
                    this.isLoading = false;
                });
            } else
                this.isLoading = false;
        }
    },
    watch: {
        selectedOfficial: {
            immediate: true,
            handler() {
                if (this.selectedOfficial) {
                    this.isLoading = true;
                    this.selectedDate = moment();
                    this.fetchMonthlyStats(this.selectedDate.year(), this.selectedDate.month() + 1).then(res => {
                        this.isLoading = false;
                    });
                } else
                    this.isLoading = false;
            }
        }

    }
};
</script>
<style scoped>
.events {
  list-style: none;
  margin: 0;
  padding: 0;
}
.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}
.notes-month {
  text-align: center;
  font-size: 28px;
}
.notes-month section {
  font-size: 28px;
}
</style>
